// components/BrandSlider.js
import React from 'react';
import styles from './BrandSlider.module.scss';

const BrandSlider = () => {
  const brands = [
    "Ručni i džepni satovi", "Zlato", "Srebro", "Dijamanti", "Penkala i upaljači", "Ordenja i medalje",
    "Zlatnici i star novac", "Stari nakit", "Druge starine"
  ];

  return (
    <div className={styles.brandSlider}>
      <div className={styles.sliderTrack}>
        {brands.concat(brands).map((brand, index) => (
          <div key={index} className={styles.slide}>
            <span>{brand}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BrandSlider;